module.exports = __webpack_public_path__ + "static/media/ce200-video.f6a4856d.png";